// extracted by mini-css-extract-plugin
export default {"homepagecategories":"CategoryCard_homepagecategories__LJ67e","categorycard":"CategoryCard_categorycard__pPwmd","carousel":"CategoryCard_carousel__MDie0"};